function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.746 4.629a.767.767 0 00-.736 0L4.535 8.161l6.475 3.532a.767.767 0 00.736 0l6.475-3.532zm-1.471-1.347a2.3 2.3 0 012.207 0l6.474 3.531a1.536 1.536 0 010 2.7l-1.047.571 1.047.571a1.536 1.536 0 010 2.7l-1.047.571 1.047.571a1.536 1.536 0 010 2.7l-6.475 3.521a2.3 2.3 0 01-2.207 0L3.8 17.187a1.536 1.536 0 010-2.7l1.047-.571-1.047-.568a1.536 1.536 0 010-2.7l1.048-.568L3.8 9.509a1.536 1.536 0 010-2.7zm-3.824 7.673L4.535 12l6.475 3.532a.767.767 0 00.736 0L18.221 12 16.3 10.955l-3.819 2.085a2.3 2.3 0 01-2.207 0zm0 3.839l-1.916 1.045 6.475 3.532a.767.767 0 00.736 0l6.475-3.532-1.921-1.045-3.819 2.085a2.3 2.3 0 01-2.207 0l-3.823-2.085z"
});

var SvgComponents = function SvgComponents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComponents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/components.f0dbf8e0.svg";
export { ForwardRef as ReactComponent };